exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.line[data-v-5c25ba20] {\n    flex-grow: 1;\n    height: 1px;\n    background-color: #e9ecef;\n}\n", ""]);

